import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { GetUserStatsDTO } from '../../dto'
import { store } from '../../store'

export const getUserStats = async ( userGroup: number[] = [ 1 ] ) => {

    let body: GetUserStatsDTO
    let response: Response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/users/stats?userGroup=${ userGroup }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_USER_STATS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_USER_STATS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_USER_STATS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetUserStatsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_USER_STATS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_USER_STATS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'GET_USER_STATS_OK', stats: body } )

}
